<template>
  <el-card shadow="never" class="aui-card--fill">
	<el-row style="background-color: #F3F4F4;">
			 <el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;"><img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />用户管理</el-col>
			 <el-col :xs="24" :md="18">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
					<el-form-item>
					  <el-button class="addBtn" style="left: 400px;" v-if="$hasPermission('sys:user:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
					</el-form-item>
					<el-form-item>
					  <el-button class="delBtn" style="left: 760px;" v-if="$hasPermission('sys:user:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
					</el-form-item>
					<el-form-item>
					  <el-button class="refreshBtn" style="left: 500px;" type="info" @click="getDataList()">刷新</el-button>
					</el-form-item>
					<el-form-item>
					  <el-button class="exportBtn" style="left: 615px;" v-if="$hasPermission('sys:user:export')" type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
					</el-form-item>
				</el-form>
			 </el-col>
	</el-row>

    <div class="mod-sys__user">
		<el-row style="border-bottom:3px solid #F3F4F4;padding-bottom: 10px;">
			  <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
				<el-form-item style="margin-top: 20px;margin-left: 20px;">
				  <el-input v-model="dataForm.username" :placeholder="$t('user.username')" clearable></el-input>
				</el-form-item>
				<el-form-item style="margin-top: 20px;margin-left: 20px;">
				  <el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
				</el-form-item>
			</el-form>
        </el-row>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        @selection-change="dataListSelectionChangeHandle"
        @sort-change="dataListSortChangeHandle"
        style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="username" :label="$t('user.username')" sortable="custom" header-align="center" align="center"></el-table-column>
        <el-table-column prop="roleName" label="角色" header-align="center" align="center"></el-table-column>
        <el-table-column prop="email" :label="$t('user.email')" header-align="center" align="center"></el-table-column>
        <el-table-column prop="mobile" :label="$t('user.mobile')" sortable="custom" header-align="center" align="center"></el-table-column>
        <el-table-column prop="gender" :label="$t('user.gender')" sortable="custom" header-align="center" align="center">
          <template slot-scope="scope">
            {{ $getDictLabel("gender", scope.row.gender) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('user.status')" sortable="custom" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" size="small" type="danger">{{ $t('user.status0') }}</el-tag>
            <el-tag v-else size="small" type="success">{{ $t('user.status1') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" :label="$t('user.createDate')" sortable="custom" header-align="center" align="center" width="180"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:user:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id,scope.row.roleName)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:user:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
	  background
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './user-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/user/pageTenantList',
        getDataListIsPage: true,
        deleteURL: '/sys/user',
        deleteIsBatch: true,
        exportURL: '/sys/user/export2'
      },
      dataForm: {
        username: '',
        deptId: '',
        gender: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>

<style lang="scss" scoped>
.mod-sys__user {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 190px);
  
  .el-row {
    flex-shrink: 0;
  }
  
  .el-table {
    flex: 1;
    margin-top: 20px;
    overflow: auto;
  }
  
  .el-pagination {
    flex-shrink: 0;
    margin-top: 20px;
    text-align: right;
  }
}
</style>